module.exports = __webpack_public_path__ + "assets/img/diy.140edcff.png";